import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';


// Components
import ModalHeader from '../../common/headers/ModalHeader';
import Button from '../../common/button/Button';
import { INPUT_TYPES } from '../../common/form/constants/fieldTypes';





const BecomeAORModal = ( props ) => {
    const {
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                memberName,
                handleAddToBOBClick
            }
        },
        modalHeaderProps
    } = props;

    const handleRestorationClick = () => {
        return window.location.href = '/hix/broker/dashboard';
    };



    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps, hideModal, hideModalCallback: handleRestorationClick } } />
            </div>
            <div className="gi-modal__body txt-left">
                <h3>
                    <FormattedMessage
                        id='selfDesignation.search.becomeAOR.modal.accept.content.1'
                        values={{
                            name: memberName.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()),
                        }}
                        tagName='strong'
                    />
                </h3>
                <FormattedMessage
                    id='selfDesignation.search.becomeAOR.modal.accept.content.2'
                    values={{
                        name: memberName,
                        strong: function makeTextStrong (message) {
                            return (<strong>{message}</strong>);
                        }
                    }}
                    tagName='p'
                />
            </div>
            <div className='gi-modal__controls'>
                <Button
                    { ...{
                        id:'cancel-btn',
                        name:'cancelBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'margin-r-10', 'display--inline'],
                        classes:['gi-button__secondary'],
                        btnText:'selfDesignation.search.action-btn.cancel',
                        handleClick: handleRestorationClick
                    }}

                />
                <Button
                    { ...{
                        id:'yes-btn',
                        name:'yesBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'display--inline'],
                        classes:['gi-button__primary'],
                        btnText:'selfDesignation.search.action-btn.yes',
                        handleClick: handleAddToBOBClick
                    }}

                />
            </div>
        </Fragment>
    );
};

export default BecomeAORModal;